import { showError } from "@/modules/error/errorStream.ts";
import { useEffect } from "react";

export function useShowError(error: unknown, message = "Error") {
    useEffect(() => {
        if (error) {
            showError(`${message}:`, error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);
}
